var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BadgeState',{attrs:{"value":_vm.stateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }